import { ActionIcon, Affix, Modal, Popover } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AgentChat } from 'src/Components/Agent/AgentChat';
import useIsMobile from 'src/Hooks/Shared/useIsMobile';

import styles from './AgentBubble.module.scss';

const HUBSPOT_LAUNCHER_OFFSET = 100;
// Above drawers and modals (Mantine default 200) so Lucien stays reachable everywhere.
const AGENT_Z_INDEX = 1000;

const AgentBubble = () => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  // A link in the chat (e.g. a created contact) leads to a page: get out of the way.
  useEffect(() => setOpened(false), [pathname]);

  const bubble = (
    <ActionIcon
      size={56}
      radius="xl"
      className={styles.bubble}
      onClick={() => setOpened(o => !o)}
      aria-label={t('agent.open')}
    >
      <IconSparkles size={26} />
    </ActionIcon>
  );

  if (isMobile) {
    // A floating panel is unusable on a phone: the chat takes the whole screen.
    return (
      <>
        <Affix position={{ bottom: HUBSPOT_LAUNCHER_OFFSET, right: 24 }} zIndex={AGENT_Z_INDEX}>
          {bubble}
        </Affix>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          fullScreen
          withCloseButton={false}
          keepMounted
          zIndex={AGENT_Z_INDEX + 1}
          padding={0}
          transitionProps={{ transition: 'slide-up' }}
        >
          <AgentChat onClose={() => setOpened(false)} />
        </Modal>
      </>
    );
  }

  return (
    // Stacked above the HubSpot chat launcher, which also sits bottom-right.
    <Affix position={{ bottom: HUBSPOT_LAUNCHER_OFFSET, right: 24 }} zIndex={AGENT_Z_INDEX}>
      {/* keepMounted: the conversation survives closing the bubble */}
      <Popover
        opened={opened}
        onChange={setOpened}
        position="top-end"
        width="min(400px, calc(100vw - 32px))"
        shadow="lg"
        keepMounted
        zIndex={AGENT_Z_INDEX}
      >
        <Popover.Target>{bubble}</Popover.Target>
        <Popover.Dropdown className={styles.dropdown}>
          <AgentChat />
        </Popover.Dropdown>
      </Popover>
    </Affix>
  );
};

export default AgentBubble;
